module.exports = __webpack_public_path__ + "img/SWT.4cc35eee.png";